const PublishSuccess = () => {
  return (
    <svg
      width="634"
      height="283"
      viewBox="0 0 634 283"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M244.326 108.869V175.566C244.326 180.895 247.171 185.819 251.784 188.481L309.543 221.829C314.156 224.497 319.845 224.497 324.458 221.829L382.217 188.481C386.83 185.813 389.675 180.895 389.675 175.566V108.869C389.675 103.54 386.83 98.615 382.217 95.9537L324.458 62.605C319.845 59.9376 314.156 59.9376 309.543 62.605L251.784 95.9537C247.171 98.6211 244.326 103.54 244.326 108.869Z"
        fill="url(#paint0_linear_985_208566)"
      />
      <path
        d="M325.035 203.614H318.776L322.141 200.243L321.107 199.209L317.993 202.323L317.736 201.907V196.315H316.274V201.907L316.023 202.323L312.909 199.209L311.875 200.243L315.24 203.614H308.976V205.076H315.24L311.875 208.441L312.909 209.475L316.078 206.306L316.274 206.612V212.375H317.736V206.612L317.938 206.306L321.107 209.475L322.141 208.441L318.776 205.076H325.035V203.614Z"
        fill="#234DD4"
      />
      <path
        d="M325.035 79.3016H318.776L322.141 75.9306L321.107 74.8967L317.993 78.0107L317.736 77.5947V72.0029H316.274V77.5947L316.023 78.0107L312.909 74.8967L311.875 75.9306L315.24 79.3016H308.976V80.7638H315.24L311.875 84.1286L312.909 85.1625L316.078 81.9934L316.274 82.2993V88.0624H317.736V82.2993L317.938 81.9934L321.107 85.1625L322.141 84.1286L318.776 80.7638H325.035V79.3016Z"
        fill="#234DD4"
      />
      <ellipse cx="317.004" cy="141.066" rx="36.6531" ry="36.6531" fill="white" />
      <path
        d="M303.064 144.6L313.265 154.279L330.942 127.851"
        stroke="#2C3244"
        strokeWidth="7.29151"
      />
      <g clipPath="url(#clip0_985_208566)">
        <path
          d="M199 48.5417H177.955L189.27 37.2069L185.793 33.7304L175.322 44.2012L174.458 42.8023V24H169.542V42.8023L168.698 44.2012L158.227 33.7304L154.751 37.2069L166.065 48.5417H145V53.4583H166.065L154.751 64.7726L158.227 68.2492L168.883 57.5932L169.542 58.6217V78H174.458V58.6217L175.137 57.5932L185.793 68.2492L189.27 64.7726L177.955 53.4583H199V48.5417Z"
          fill="#A3E1FF"
        />
      </g>
      <g clipPath="url(#clip1_985_208566)">
        <path
          d="M85 192.361H70.9703L78.5132 184.805L76.1954 182.487L69.2148 189.467L68.6388 188.535V176H65.361V188.535L64.7989 189.467L57.8182 182.487L55.5006 184.805L63.0434 192.361H49V195.639H63.0434L55.5006 203.182L57.8182 205.499L64.9223 198.395L65.361 199.081V212H68.6388V199.081L69.0915 198.395L76.1954 205.499L78.5132 203.182L70.9703 195.639H85V192.361Z"
          fill="#FFA064"
        />
      </g>
      <g clipPath="url(#clip2_985_208566)">
        <path
          d="M462 82.9074H452.647L457.675 77.8698L456.13 76.3246L451.477 80.9783L451.093 80.3566V72H448.907V80.3566L448.533 80.9783L443.879 76.3246L442.334 77.8698L447.362 82.9074H438V85.0926H447.362L442.334 90.1211L443.879 91.6663L448.615 86.9303L448.907 87.3874V96H451.093V87.3874L451.394 86.9303L456.13 91.6663L457.675 90.1211L452.647 85.0926H462V82.9074Z"
          fill="#72D3A6"
        />
      </g>
      <g clipPath="url(#clip3_985_208566)">
        <path
          d="M539 194.907H529.647L534.675 189.87L533.13 188.325L528.477 192.978L528.093 192.357V184H525.907V192.357L525.533 192.978L520.879 188.325L519.334 189.87L524.362 194.907H515V197.093H524.362L519.334 202.121L520.879 203.666L525.615 198.93L525.907 199.387V208H528.093V199.387L528.394 198.93L533.13 203.666L534.675 202.121L529.647 197.093H539V194.907Z"
          fill="#F6B1C3"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_985_208566"
          x1="369.246"
          y1="8.04507"
          x2="187.816"
          y2="78.6861"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00362812" stopColor="#FFA064" />
          <stop offset="0.291667" stopColor="#FF9864" />
          <stop offset="0.9992" stopColor="#FF8264" />
          <stop offset="1" stopColor="#FF8264" />
        </linearGradient>
        <clipPath id="clip0_985_208566">
          <rect width="54" height="54" fill="white" transform="translate(145 24)" />
        </clipPath>
        <clipPath id="clip1_985_208566">
          <rect width="36" height="36" fill="white" transform="translate(49 176)" />
        </clipPath>
        <clipPath id="clip2_985_208566">
          <rect width="24" height="24" fill="white" transform="translate(438 72)" />
        </clipPath>
        <clipPath id="clip3_985_208566">
          <rect width="24" height="24" fill="white" transform="translate(515 184)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { PublishSuccess };
